export default "__VITE_ASSET__CTFaHo4y__"